export default __webpack_public_path__ + "static/media/NotoSerif-Italic.f002eca6.woff";